<template>
  <app-page-wrapper class="max-w-screen-lg py-12 md:py-sections">
    <div v-if="data" class="prose">
      <h1>{{ data.title }}</h1>
      <div v-html="data.html" />
    </div>

    <div v-else>
      <app-skeleton-text class="mb-6 bg-gray-100" :height="40" width="40%" />

      <app-skeleton-paragraph class="mb-6" />

      <app-skeleton-paragraph />
    </div>
  </app-page-wrapper>
</template>

<script lang="ts" setup>
const slug = useRoute("content-slug").params.slug;

const { data } = useLazyFetch(`/api/legal/${slug}`);

definePageMeta({
  noFaq: true,
});

useSeoMeta({
  title: () => data.value?.title ?? "",
});
</script>
